import React, { useState, useCallback, Fragment, useEffect } from 'react';
import { useNotify } from 'react-admin';
import { IconButton, Button, Box, Grid, Paper, CircularProgress, TextField, Typography, Divider } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import UpdateIcon from '@mui/icons-material/Update';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { ruleList } from '../editor/RuleStatic';
import client from '../common/client';

const sx = {
    root: {
        display: 'flex',
        alignItems: 'center'
    }
}

const ConfirmDialog = props => {

}

const RuleList = props => {
    const notify = useNotify();
    const [loading, setLoading] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [rows, setRows] = useState([{}]);

    useEffect(() => {
        
    }, [props.list])

    const handleEdit = (event, row) => {
        if (props.edit)
            props.edit(row)
    };

    const handleRemove = (event, row) => {
        if (window.confirm('Do you want to remove the rule?')) {
            setLoadingDelete(true)
            client.request_get(`/api/rule/remove/${row.id}`).then(res => {
                setLoadingDelete(false)
                if (res.r) {
                    notify('Rule Removed')
                    if (props.changed)
                        props.changed()
                } else
                    notify(res.msg, 'error')
                
            }).catch(e => {
                setLoadingDelete(false)
                notify(e)
            })
        }
    };

    return (
        <Fragment>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Node</TableCell>
                            <TableCell>Value</TableCell>
                            <TableCell>Error</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.list && props.list.map((row) => (
                            <TableRow key={row.id}>
                                <TableCell>
                                    {row.node}
                                </TableCell>
                                <TableCell>
                                    {row.value}
                                </TableCell>
                                <TableCell>
                                    <Typography component="h2" color="error">
                                        {row.err}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <IconButton color="primary">
                                        <EditIcon onClick={(e) => handleEdit(e, row)}/>
                                    </IconButton>
                                    &nbsp;
                                    <IconButton color="primary" disabled={loadingDelete} >
                                        <DeleteOutlineIcon onClick={(e) => handleRemove(e, row)}/>
                                    </IconButton>
                                    
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Fragment>
    );
};

export default RuleList;
